// Names 
export const data = {
    "Persons": [
        // List of 100 names of famous persons:
        'Albert Einstein',
        'Benjamin Franklin',
        'Bill Gates',
        'Bruce Lee',
        'Charles Darwin',
        'Christopher Columbus',
        'Dennis Ritchie',
        'Douglas Adams',
        'Edsger Dijkstra',
        'Elon Musk',
        'Franklin D. Roosevelt',
        'Gandhi',
        'Grace Hopper',
        'Haskell Curry',
        'Ilya Prigogine',
        'James Gosling',
        'John von Neumann',
        'Linus Torvalds',
        'Louis Pasteur',
        'Martin Luther King',
        'Michael Faraday',
        'Nikola Tesla',
        'Steve Jobs',
        'Steve Wozniak',
        'Thomas Edison',
        'Vint Cerf',
    ],
    // List of 100 names of famous cities:
    "Cities": [
        'Athens',
        'Beijing',
        'Berlin',
        'Bogotá',
        'Buenos Aires',
        'Cairo',
        'Chicago',
        'Delhi',
        'Dhaka',
        'Dresden',
        'Dublin',
        'Essen',
        'Florence',
        'Frankfurt',
        'Geneva',
        'Hamburg',
        'Hong Kong',
        'Houston',
        'Istanbul',
        'Jakarta',
        'Jerusalem',
        'Kiev',
        'Kyoto',
        'Lisbon',
        'London',
        'Los Angeles',
        'Madrid',
        'Manila',
        'Mexico City',
        'Moscow',
        'Mumbai',
        'New York',
        'Oslo',
        'Paris',
        'Philadelphia',
        'Phoenix',
        'Prague',
        'Rio de Janeiro',
        'Rome',
        'Santiago',
        'Seoul',
        'Shanghai',
        'Sofia',
        'Stockholm',
        'Sydney',
        'Taipei',
        'Tokyo',
        'Toronto',
        'Vienna',
        'Warsaw',
        'Washington D.C.',
        'Zurich',
    ],
    // List of 100 names of famous companies:
    "Brands": [
        'Adidas',
        'Airbnb',
        'Apple',
        'Amazon',
        'BMW',
        'Cisco',
        'Coca-Cola',
        'Coca-Cola Zero',
        'Dell',
        'Facebook',
        'Ford',
        'Google',
        'IBM',
        'Intel',
        'Jaguar',
        'McDonald\'s',
        'Microsoft',
        'Nestle',
        'Nike',
        'Oracle',
        'Pepsi',
        'Porsche',
        'Samsung',
        'Sony',
        'Tesla',
        'Twitter',
        'Uber'
    ]
};
